module.exports = __webpack_public_path__ + "static/img-dark-night-661178f4c24689a136e13291f24f3510.jpg";